export default "__VITE_ASSET__VQ4RU60h__"